import { INbDropdownItem, INbDropdownOptions } from './nb-dropdown';

export type INbSelectItem = INbDropdownItem;

export type INbSelectOptions = INbDropdownOptions;

export const defaultOptions: INbSelectOptions = {
  placeholder: 'Select...',
  autoClose: true,
  closeOnClick: true,
  placement: 'bottom left',
  labelField: 'label',
  valueField: 'value',
  itemClass: [],
};
